import { createContext } from "react";
import { Company, User } from "src/api/client-api/useUserNew";

export type UserInitialValues = {
    user: User;
    selectedCompany: Company;
};
export const UserContext = createContext<UserInitialValues | null>(null);
